import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { WEB3FORMS_ACCESS_KEY } from '../../config/web3forms';

const ContactForm = (props) => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState('idle'); // idle | submitting | success | error
    const [, setTick] = useState(0); // force re-render so validation messages show
    const rerender = () => setTick((t) => t + 1);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async e => {
        e.preventDefault();
        if (!validator.allValid()) {
            validator.showMessages();
            rerender();
            return;
        }
        validator.hideMessages();
        setStatus('submitting');

        try {
            const response = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    access_key: WEB3FORMS_ACCESS_KEY,
                    subject: 'New contact request — BUILDLAB website',
                    from_name: 'BUILDLAB Website',
                    name: forms.name,
                    email: forms.email,
                    phone: forms.phone,
                    message: forms.message,
                }),
            });
            const data = await response.json();
            if (data.success) {
                setStatus('success');
                setForms({ name: '', email: '', subject: '', phone: '', message: '' });
                validator.hideMessages();
            } else {
                setStatus('error');
            }
        } catch (err) {
            setStatus('error');
        }
    };

    return (
        <form onSubmit={submitHandler}>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input_title" htmlFor="input_name">Full Name
                        </label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            className="form-control"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Jane Smith" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input_title" htmlFor="input_email">Your Email
                        </label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            className="form-control"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="you@company.com" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label className="input_title" htmlFor="input_phone">Your Phone</label>
                        <input
                            value={forms.phone}
                            type="phone"
                            name="phone"
                            className="form-control"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="(858) 952-6234" />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label className="input_title" htmlFor="input_textarea">Message</label>
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            className="form-control"
                            placeholder="How can we help you?">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>

                    {status === 'success' && (
                        <div style={{ background: 'var(--bs-success-bg-subtle, #d1e7dd)', color: '#0f5132', border: '1px solid #badbcc', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontWeight: 500 }}>
                            Thanks — your message is on its way. We'll get back to you shortly.
                        </div>
                    )}
                    {status === 'error' && (
                        <div style={{ background: 'var(--bs-danger-bg-subtle, #f8d7da)', color: '#842029', border: '1px solid #f5c2c7', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontWeight: 500 }}>
                            Something went wrong sending your message. Please email us directly at info@buildlabconsulting.com or call (858) 952-6234.
                        </div>
                    )}

                    <button type="submit" className="btn btn-primary" disabled={status === 'submitting'}>
                        <span className="btn_label" data-text={status === 'submitting' ? 'Sending…' : 'Send Message'}>{status === 'submitting' ? 'Sending…' : 'Send Message'}</span>
                        <span className="btn_icon">
                            <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    )
}

export default ContactForm;
